export default "__VITE_ASSET__CXlTyiK7__"